<cosmos-expandable-panel
  [accordionItems]="_accordionData"
  [numberOfColumns]="2"
  panelTitle="User Details"
></cosmos-expandable-panel>

<ng-template #editDetails>
  <button
    (click)="editUser()"
    class="cosmos-user-summary__button"
  >
    Edit User
  </button>
</ng-template>

<ng-template #deleteUserTemplate>
  <div class="cosmos-user-summary__button-wrapper">
    <button
      (click)="deleteUser()"
      class="cosmos-user-summary__delete-button"
    >
      <mat-icon class="cosmos-user-summary__delete-button__icon">
        <span>delete_outline</span>
      </mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #email>
  <div class="cosmos-user-summary__email">
    <span class="cosmos-user-summary__email__label">Email: </span>
    <div class="cosmos-user-summary__email__label__data-wrapper">
      <span
        [title]="_user.email"
        class="cosmos-user-summary__email__label__data"
      >
        {{ _user.email | trimText: 35 }}
      </span>
      <button
        [cdkCopyToClipboard]="_user.email"
        (click)="showCopyToastMessage()"
        class="cosmos-user-summary__email__label__button"
      >
        <mat-icon>
          <span class="cosmos-user-summary__email__label__button__icon">content_copy</span>
        </mat-icon>
      </button>
    </div>
  </div>
</ng-template>
